import { ISeatStateData, UserInfoData, IRoomInfoData } from "../../../table/module/poker_table/poker_table_data_interface";

const { ccclass, property } = cc._decorator;



export class BlackJackRoomInfo {
    roomId:string
    rule: string
    ruleTable: any
    playerCount: number
    roundCount: number
    curRoundNum: number
    // mySeatInfo: BlackJackSeatInfo
    // seatInfoList: BlackJackSeatInfo[]
    serverNowTimestamp: number
    timeOffset: number
    isGoldTable?: boolean

    basePoint:number
    limitPoint:number
    bankerHistory:number[]
    minPoint: number=0;
    maxPoint:number=0;
    roomMaxSeatNo:number
    
    totalTime = 15;//总共执行时间
}

export enum ButtonState{
    None = 0,     
    Init_Button = 1,//自动过/弃牌
    Show_Bet = 2,//显示下注
    Show_Operate = 3,//显示操作
    Show_Insurance = 4,//显示保险
    
}
export enum BlackJackGameState{
    //状态 0下注阶段 1 已经发第一张牌 2 已经发第二张牌 3买保险阶段（该阶段由庄家明牌为A时触发）  4操作阶段
    Beting = 0,       //下注
    Give_One_Card=1,  // 发第一张牌
    Give_Two_Card=2,  //发第二张牌
    Buy_Insurance = 3,//买保险
    Operateing = 4,//操作阶段 
    AskEvent=888,//节奏控制
}
export enum GameResultState{
    //结算原因 1保险 2完美对子结算 3、21+3结算 4、爆牌结算
    Reset=-1,
    GameOver=0,    //总结算
    Insurance = 1,       //保险
    PairPoker=2,  // 完美对子结算
    ThreePoker=3,  //21+3结算
    bombPoker = 4,//爆牌结算
}
export enum BlackJackBetType{//0 表示 底注 1表示完美对子 2表示21+3 4续压 5旁注
    base = 0,       //底注
    pair=1,  // 完美对子
    three=2,  //21+3
    contBet = 4, //续押
    side=5,//旁注
}
export enum BlackJackCardState{
    //0 正常 1已经拿到黑杰克停牌,2 五小龙 3、21点停牌 5爆牌停牌（庄家全赔）
    Normal = 0,       //正常
    Blackjack=1,  // 黑杰克停牌
    Five_Dragon=2,  //五小龙
    TwoOne = 3, //21点
    Bomb=5,//爆牌停牌
}
export enum BlackJackChipPos{
    base = 0,       //正常
    pair=1,  // 黑杰克停牌
    three=2,  //21点停牌
    side = 3,//旁注
    insurance = 4,//保险
    leftBase = 5,       //左手筹码位置
    rightBase = 6,       //右手筹码位置
}
export class BlackJackSeatInfo {
    
    playerId: number = 0
    
    coinBalance: number = 0
    
    //座位号
    seatNo: number;
    
    
    reset(){
        this.playerId = 0
        
        
    }

    constructor(playerId: number){
        this.playerId = playerId
        
    }
    
   
}

